/** @format */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { history } from '../../core/history';

import TariffSelectComponent from '../../components/Adescom/TariffSelectApi';
import GeoLoactionSelectComponent from '../../components/Adescom/GeoLocationStateSelectApi';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';

import CustomButtom from '../../components/CustomButtons/ButtonExt';
import CancelTextButton from '../../components/Buttons/CancelTextButtons';

import Person from '@material-ui/icons/Person';
import AccountBalance from '@material-ui/icons/AccountBalance';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import InputFormRest from '../../components/Form/InputFormRest';
import CheckBoxFormRest from '../../components/Form/CheckBoxFormRest';

import { ClientEntity, ClientEntityErrorState } from '../../modules/clients/Entity';
import SnackBarMessage from '../../helpers/SnackBarMessage';
import { clientsActions, clientsConstants } from '../../modules/clients/actions';

class ClientsAdd extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            entity: ClientEntity,
            entityStatus: ClientEntityErrorState,

            snackBarStatus: false,
            snackBarMessage: '',
            snackBarVariant: 'success',

            success: false,
            id: null,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.success === true) {
            history.push({
                pathname: FormGeneralHelper.getRouteUrl('/clients-edit' + nextProps.id),
            });
            return false;
        }
        return true;
    }

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue);
    };

    returnClientList = () => {
        history.push(FormGeneralHelper.getRouteUrl('/clients-list'));
    };

    submitCallBackDispatch = () => {
        const { dispatch } = this.props;
        dispatch(clientsActions.post(FormGeneralHelper.getUrl('/clients'), this.state.entity, clientsConstants.CLIENT_ADD));
    };

    handleCheckBoxCallback = (checked, stateName) => {
        FormGeneralHelper.handleCheckBox(this, checked, stateName);
    };

    handleSubmit = (e) => {
        FormGeneralHelper.handleSubmit(this, e, this.submitCallBackDispatch, true);
    };

    closeSnackbarCallback = () => {
        this.setState({ snackBarStatus: false, snackBarMessage: '' });
    };

    selectFunc = (e, stateName, require) => {
        FormGeneralHelper.selectFunc(this, e, stateName, require);
    };

    render() {
        const { classes } = this.props;
        const { entity, entityStatus } = this.state;
        return (
            <form onSubmit={this.handleSubmit} key="client_form">
                <GridContainer>
                    <GridItem xs={12} sm={12} md={8}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="info">
                                    <Person />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>Client</h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="firstname"
                                            stateObjectState={entityStatus.firstname}
                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="First name"
                                            vMax={256}
                                            vMin={-1}
                                            required={false}
                                            value={entity.firstname}
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="mainname"
                                            stateObjectState={entityStatus.mainname}
                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="Name"
                                            required={true}
                                            vMax={256}
                                            vMin={-1}
                                            value={entity.mainname}
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="email"
                                            stateObjectState={entityStatus.email}
                                            typeCallback={FormGeneralHelper.TYPE_EMAIL}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="Email"
                                            required={false}
                                            vMax={-1}
                                            vMin={-1}
                                            value={entity.email}
                                        />
                                        <CheckBoxFormRest
                                            stateName="isPrivateClient"
                                            checked={entity.isPrivateClient}
                                            label={'Is private client'}
                                            callback={this.handleCheckBoxCallback}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="street"
                                                    stateObjectState={entityStatus.street}
                                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="Street"
                                                    required={false}
                                                    vMax={256}
                                                    vMin={-1}
                                                    value={entity.street}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="house"
                                                    stateObjectState={entityStatus.house}
                                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="House"
                                                    required={false}
                                                    vMax={32}
                                                    vMin={-1}
                                                    value={entity.house}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="apartment"
                                                    stateObjectState={entityStatus.apartment}
                                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="Apartment"
                                                    required={false}
                                                    vMax={32}
                                                    vMin={-1}
                                                    value={entity.apartment}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="zip"
                                                    stateObjectState={entityStatus.zip}
                                                    typeCallback={FormGeneralHelper.TYPE_ZIP}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="Zip code 00-000"
                                                    required={true}
                                                    vMax={64}
                                                    vMin={5}
                                                    value={entity.zip}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="city"
                                                    stateObjectState={entityStatus.city}
                                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="City"
                                                    required={false}
                                                    vMax={256}
                                                    vMin={-1}
                                                    value={entity.city}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <GeoLoactionSelectComponent
                                                    callbackSelect={this.selectFunc}
                                                    stateIdState={entityStatus.altStateId}
                                                    stateIdSelected={entity.altStateId}
                                                    stateName="altStateId"
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="country"
                                                    stateObjectState={entityStatus.country}
                                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="Country"
                                                    required={false}
                                                    vMax={64}
                                                    vMin={-1}
                                                    value={entity.country}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="info">
                                    <AccountBalance />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>Billing</h4>
                            </CardHeader>
                            <CardBody>
                                <TariffSelectComponent
                                    callbackSelect={this.selectFunc}
                                    tariffIdState={entityStatus.tariffId}
                                    tariffIdSelected={entity.tariffId}
                                    stateName="tariffId"
                                />
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="nip"
                                    stateObjectState={entityStatus.nip}
                                    typeCallback={FormGeneralHelper.TYPE_NIP}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="NIP"
                                    required={false}
                                    vMax={10}
                                    value={entity.nip}
                                />
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="bankaccount"
                                    stateObjectState={entityStatus.bankaccount}
                                    typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="Bank account"
                                    required={false}
                                    vMax={34}
                                    vMin={-1}
                                    value={entity.bankaccount}
                                />
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="user1"
                                    stateObjectState={entityStatus.user1}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="User field 1"
                                    required={false}
                                    vMax={-1}
                                    vMin={-1}
                                    value={entity.user1}
                                />
                                <InputFormRest
                                    classes={classes}
                                    callback={this.change}
                                    stateName="user2"
                                    stateObjectState={entityStatus.user2}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="User field 2"
                                    required={false}
                                    vMax={-1}
                                    vMin={-1}
                                    value={entity.user1}
                                />
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomButtom type="submit" >
                            {'Save client'}
                        </CustomButtom>
                        <CancelTextButton callback={this.returnClientList} />
                    </GridItem>
                </GridContainer>
                <SnackBarMessage
                    closeCallback={this.closeSnackbarCallback}
                    open={this.state.snackBarStatus}
                    text={this.state.snackBarMessage}
                    variant={this.state.snackBarVariant}
                />
            </form>
        );
    }
}

ClientsAdd.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    const { clientsReducers } = state;
    if (clientsReducers === undefined) {
        return { ...state };
    }
    let id = null;
    if (clientsReducers.data) {
        id = clientsReducers.data['@id'];
    }
    return {
        success: clientsReducers.success,
        id: id,
    };
};

const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));

const Enhance = enhance(ClientsAdd);
export default Enhance;
